import { QueryClient } from "@tanstack/react-query";

/** Outside the provider so interceptors, sagas and query helpers can use it without the React tree. */
export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 60 * 1000,
      retry: 2,
    },
  },
});
